/**
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */

export { NzDescriptionsModule } from './descriptions.module';
export { NzDescriptionsComponent } from './descriptions.component';
export { NzDescriptionsItemComponent } from './descriptions-item.component';

export * from './typings';
